module.exports = __webpack_public_path__ + "img/condicionesComerciales.e93a04f5.svg";